// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("./assets/migration-welcome-close.svg");
var ___CSS_LOADER_URL_IMPORT_1___ = require("./assets/migration-welcome-smile.svg");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hus7zi dialog {
  width: 700px;
  height: 500px;
  max-width: calc(100vw - 32px);
  border-radius: 4px;
  padding: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
}

.hus7zi [data-testid\$='-backdrop'] {
  background: rgba(31, 31, 31, 0.6);
}

.hus7zi [data-testid\$='-header'] {
  padding: 28px;
}

.hus7zi [data-testid\$='-close-button'] {
  border-radius: 4px;
  background: white url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center no-repeat;
}

.hus7zi [data-testid\$='-close-button'] svg {
  visibility: hidden;
}

.hus7zi [data-testid\$='-body'] {
  height: 100%;
  overflow: hidden;
}

.hus7zi [data-testid\$='-header-section'] {
  height: 200px;
  flex: none;
  overflow: hidden;
  border-radius: 4px;
  background: linear-gradient(90deg, rgba(230, 230, 230, 0), #e6e6e6);
}

.hus7zi [data-testid\$='-header-section'] img {
  position: absolute;
  width: 572px;
  height: 392.456px;
  top: -59px;
  left: 60px;
  max-width: none;
  object-fit: cover;
}

.hus7zi [data-testid\$='-content']:not(dialog) {
  flex: 1;
  min-height: 0;
  padding: 40px 24px;
  gap: 24px;
}

.hus7zi [data-testid\$='-content']:not(dialog) > :first-child {
  filter: none;
  content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.hus7zi [data-testid\$='-text'] {
  max-width: 500px;
  gap: 8px;
}

.hus7zi h2 {
  font-size: 20px;
  font-weight: 600;
  line-height: normal;
  color: black;
}

.hus7zi p {
  font-size: 14px;
  font-weight: 400;
  line-height: 1.8;
}

.hus7zi [data-testid\$='-actions'] {
  gap: 16px;
}

.hus7zi [data-testid\$='-actions'] button {
  height: 40px;
  min-height: 40px;
  padding: 8px 12px;
  --size: 14px;
  font-size: 14px;
  line-height: normal;
  border-radius: 4px;
  white-space: nowrap;
}

.hus7zi [data-testid\$='-secondary-button'] {
  width: 100px;
  min-width: 100px;
}

.hus7zi [data-testid\$='-primary-button'] {
  width: 162px;
}

@media (max-width: 768px) {
  .hus7zi dialog {
    height: auto;
  }

  .hus7zi [data-testid\$='-header-section'] img {
    left: calc(50% - 286px);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/HomePageEmissor/components/MigrationWelcomeModal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,0EAA8E;AAChF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,mEAAmE;AACrE;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,gDAAoD;AACtD;;AAEA;EACE,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".presentation :global(dialog) {\n  width: 700px;\n  height: 500px;\n  max-width: calc(100vw - 32px);\n  border-radius: 4px;\n  padding: 4px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);\n}\n\n.presentation :global([data-testid$='-backdrop']) {\n  background: rgba(31, 31, 31, 0.6);\n}\n\n.presentation :global([data-testid$='-header']) {\n  padding: 28px;\n}\n\n.presentation :global([data-testid$='-close-button']) {\n  border-radius: 4px;\n  background: white url('./assets/migration-welcome-close.svg') center no-repeat;\n}\n\n.presentation :global([data-testid$='-close-button'] svg) {\n  visibility: hidden;\n}\n\n.presentation :global([data-testid$='-body']) {\n  height: 100%;\n  overflow: hidden;\n}\n\n.presentation :global([data-testid$='-header-section']) {\n  height: 200px;\n  flex: none;\n  overflow: hidden;\n  border-radius: 4px;\n  background: linear-gradient(90deg, rgba(230, 230, 230, 0), #e6e6e6);\n}\n\n.presentation :global([data-testid$='-header-section'] img) {\n  position: absolute;\n  width: 572px;\n  height: 392.456px;\n  top: -59px;\n  left: 60px;\n  max-width: none;\n  object-fit: cover;\n}\n\n.presentation :global([data-testid$='-content']:not(dialog)) {\n  flex: 1;\n  min-height: 0;\n  padding: 40px 24px;\n  gap: 24px;\n}\n\n.presentation :global([data-testid$='-content']:not(dialog) > :first-child) {\n  filter: none;\n  content: url('./assets/migration-welcome-smile.svg');\n}\n\n.presentation :global([data-testid$='-text']) {\n  max-width: 500px;\n  gap: 8px;\n}\n\n.presentation :global(h2) {\n  font-size: 20px;\n  font-weight: 600;\n  line-height: normal;\n  color: black;\n}\n\n.presentation :global(p) {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.8;\n}\n\n.presentation :global([data-testid$='-actions']) {\n  gap: 16px;\n}\n\n.presentation :global([data-testid$='-actions'] button) {\n  height: 40px;\n  min-height: 40px;\n  padding: 8px 12px;\n  --size: 14px;\n  font-size: 14px;\n  line-height: normal;\n  border-radius: 4px;\n  white-space: nowrap;\n}\n\n.presentation :global([data-testid$='-secondary-button']) {\n  width: 100px;\n  min-width: 100px;\n}\n\n.presentation :global([data-testid$='-primary-button']) {\n  width: 162px;\n}\n\n@media (max-width: 768px) {\n  .presentation :global(dialog) {\n    height: auto;\n  }\n\n  .presentation :global([data-testid$='-header-section'] img) {\n    left: calc(50% - 286px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"presentation": `hus7zi`
};
module.exports = ___CSS_LOADER_EXPORT___;
